// extracted by mini-css-extract-plugin
export var orderDetails = "_sl-2";
export var orderImage = "_sl-1";
export var orderMeta = "_sl-3";
export var orderSummary = "_sl-0";
export var rightArrow = "_sl-4";